import Components from "slotworks/components/components";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import { formatMoney } from "slotworks/utils/string-formatters";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import Translations from "slotworks/i18n/translations";
import Contract from "slotworks/utils/contract";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";

export default class SummaryPopup {
    private static TEXT: string = "text";
    private static BUTTON_EXIT: string = "btn-exit";

    private closeButton: FlexiButton;
    private text: FlexiText;

    constructor() {
    }

    private setupListeners() {
        this.closeButton = Layers.PromoPopups.getFlexiButton(SummaryPopup.BUTTON_EXIT);
        this.closeButton.setEnabled(true);
        this.text = Layers.PromoPopups.getFlexiText(SummaryPopup.TEXT);
    }

    private translate() {
        let text = Translations.get(
            'promo_fs_result',
            {
                spins: CampaignsModel.freespins.total,
                win: formatMoney(CampaignsModel.freespins.totalWin)
            }
        )
        this.text.setText(text);
    }

    public show(): Contract<void> {
        return new Contract((resolve) => {
            Components.promoBetBar.setEnabled(false);
            Components.promoBetBar.setTotalWin(CampaignsModel.freespins.totalWin);
            smartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE,true);
            Layers.PromoPopups.setScene("promosummary").execute();
            this.setupListeners();
            this.closeButton.on(ButtonEvent.POINTER_UP,()=>this.close(resolve));
            this.translate();
            Layers.PromoPopups.show();
        })
    }

    public close(resolve: Function) {
        this.destroy();
        resolve(null);
    }

    public destroy() {
        this.closeButton.off(ButtonEvent.POINTER_UP,()=>this.close(null));
        this.closeButton.destroy();
        this.text.destroy();
        Layers.PromoPopups.defaultScene().execute();
        Layers.PromoPopups.hide();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/promo-popups/summary-popup.ts